import * as React from "react";
const SvgFiRrPodium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-podium_svg__a)">
      <path
        fill="#062147"
        d="M23 10H4V7c0-1.654 1.346-3 3-3h.172A3 3 0 0 0 10 6h3c1.654 0 3-1.346 3-3s-1.346-3-3-3h-3a3 3 0 0 0-2.828 2H7C4.243 2 2 4.243 2 7v3H1a1 1 0 0 0 0 2h1.153l1.304 7.821A4.984 4.984 0 0 0 8.389 24h7.223a4.98 4.98 0 0 0 4.932-4.179L21.848 12h1.153A1 1 0 1 0 23 10M10 2h3c.551 0 1 .449 1 1s-.449 1-1 1h-3c-.551 0-1-.449-1-1s.449-1 1-1m8.571 17.493A2.99 2.99 0 0 1 15.612 22H8.389a2.99 2.99 0 0 1-2.959-2.507L4.181 12H19.82z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-podium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPodium;
